// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3o435","errorLogs":"styles_errorLogs__15T6U"};